import { css } from 'styled-components';

export const ThinScrollbar = css`
  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    background: #fafafa;
  }

  &::-webkit-scrollbar-thumb {
    background: #ccc;
  }
`;
